import { Component, Input } from '@angular/core';
@Component({
  selector: 'payarc-section-title',
  template: `<h3 class="pa-sec">{{ label }}<small *ngIf="sub"> {{ sub }}</small></h3>`,
  styleUrls: ['./payarc-section-title.component.css'],
  standalone: false
})
export class PayarcSectionTitleComponent {
  @Input() label = '';
  @Input() sub?: string;
}
